import styled, { css } from "styled-components";
import { Flex } from "rebass/styled-components";
import { ChevronDown } from "styled-icons/boxicons-regular";

export const SelectorContainer = styled(Flex)<{ $disabled?: boolean }>`
  align-items: center;
  align-self: flex-start;
  cursor: pointer;
  gap: 6px;
  min-width: 0;
  max-width: 100%;
  padding: 3px 10px;
  border: 1px solid ${props => props.theme.colors.grey02};
  border-radius: 48px;
  background-color: ${props => props.theme.colors.grey01};
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease;

  &:hover {
    border-color: ${props => props.theme.colors.grey03};
    background-color: ${props => props.theme.colors.grey02};

    svg {
      color: ${props => props.theme.colors.text01};
    }
  }

  ${props =>
    props.$disabled &&
    css`
      opacity: 0.6;
      pointer-events: none;
    `}
`;

export const SelectorPrefix = styled.span`
  flex-shrink: 0;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  color: ${props => props.theme.colors.text03};
`;

export const SelectorLabel = styled.span`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  color: ${props => props.theme.colors.text01};
`;

export const SelectorChevron = styled(ChevronDown)`
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  color: ${props => props.theme.colors.text03};
  transition: color 0.15s ease;
`;

export const MenuEntry = styled.div<{
  $selected: boolean;
  $disabled?: boolean;
}>`
  gap: 12px;
  padding: 8px;
  display: flex;
  cursor: pointer;
  align-items: center;
  border-radius: 10px;
  align-self: stretch;
  justify-content: space-between;

  ${props =>
    props.$selected &&
    css`
      background: ${props.theme.colors.grey01};
    `}

  .label {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 17.5px;
    color: ${props => props.theme.colors.text01};
    font-weight: ${props => (props.$selected ? 600 : 500)};
  }

  .hint {
    font-size: 12px;
    font-weight: 400;
    line-height: 15.6px;
    color: ${props => props.theme.colors.text03};
  }

  > i {
    font-size: 18px;
    color: ${props => props.theme.colors.text03};
  }

  &:hover {
    background: ${props => props.theme.colors.primary};

    .label,
    .hint,
    > i {
      color: ${props => props.theme.colors.white};
    }
  }

  ${props =>
    props.$disabled &&
    css`
      cursor: not-allowed;

      .label {
        color: ${props.theme.colors.text03};
      }

      &:hover {
        background: transparent;

        .label,
        .hint {
          color: ${props.theme.colors.text03};
        }
      }
    `}
`;
